import { add, endOfDay, startOfWeek } from "date-fns";

export const months = [
  { label: 'January', value: 1 },
  { label: 'February', value: 2 },
  { label: 'March', value: 3 },
  { label: 'April', value: 4 },
  { label: 'May', value: 5 },
  { label: 'June', value: 6 },
  { label: 'July', value: 7 },
  { label: 'August', value: 8 },
  { label: 'September', value: 9 },
  { label: 'October', value: 10 },
  { label: 'November', value: 11 },
  { label: 'December', value: 12 },
];

export const next50Years = Array.from(new Array(50), (val, index) => new Date().getFullYear() + index);

export const days = Array.from(new Array(31), (val, index) => index + 1);

export const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;

export const dayOptions = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' }
];

export const getWeekDays = (date) => {
  const start = startOfWeek(new Date(date))
  return [...Array(7)].map((d, i) => (i === 6 ? endOfDay(add(start, { days: i })) : add(start, { days: i })))
}

export const shiftWeek = (days: Date[], offset: number) => days.map((d) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + offset))
